import { Injectable } from "@angular/core";
import { LoginRequest } from "../../../../core/domain/requests";
import { catchError, map, Observable } from "rxjs";
import { AccountRepository } from "../../../../core/repositories";
import { Authorize, BaseResponse, RefreshToken } from "../../../../core/domain/models";
import { AccountApiUrls } from "./account-api-urls";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { AuthorizeWebEntity } from "./authorize.web-entity";
import { AuthorizeWebRepositoryMapper } from "./authorize.web-repository-mapper";
import { injectEnvironment } from "master-locations-library/master-locations-library/src/lib/core/environments/environment.token";

@Injectable({providedIn: 'root'})
export class AccountWebRepository extends AccountRepository {

  authorizeMapper = new AuthorizeWebRepositoryMapper();
  private environment = injectEnvironment();

  constructor(private http: HttpClient) {
    super();
  }

  login(request: LoginRequest): Observable<Authorize> {
    return this.http
      .post<BaseResponse<AuthorizeWebEntity>>(
        `${this.environment.url}${AccountApiUrls.Login}`,
        request
      )
      .pipe(
        map((data: BaseResponse<AuthorizeWebEntity>) => {
          return data.result;
        }),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      ).pipe(map(this.authorizeMapper.mapFrom));
  }

  override refreshToken(request: RefreshToken): Observable<Authorize> {
    return this.http
    .post<BaseResponse<AuthorizeWebEntity>>(
      `${this.environment.url}${AccountApiUrls.RefreshToken}`,
      request
    )
    .pipe(
      map((data: BaseResponse<AuthorizeWebEntity>) => {
        return data.result!;
      }),
      catchError((err) => {
        throw err;
      })
    ).pipe(map(this.authorizeMapper.mapFrom));
  }
}
